module.exports = __webpack_public_path__ + "ae3cffd6f484cb72c1680e4ff881b48c.pdf";